import Axios from "axios";
import {
  LOGIN,
  LOGOUT,
  UPDATE_USER,
  UPDATE_CART,
  SET_IS_AUTH,
  ADD_STORE,
  ADD_PRODUCT_DETAILS,
  ADD_CART,
  UPDATE_MESSAGE_COUNT,
  REMOVE_CART_FROM_STORE,
  UPDATE_USER_AND_CART,
} from "../../constants/actionTypes";
export const login = (data) => {
  if (data.token) {
    localStorage.setItem("token", data.token);
    Axios.defaults.headers.common["Key"] = data.token;
  }
  return {
    type: LOGIN,
    data,
  };
};

export const autoLogin = () => {
  return (dispatch) => {
    const token = localStorage.getItem("token");
    if (token && token.length > 8) {
      dispatch(login({ token, me: {} }));
      Axios.defaults.headers.common["Key"] = token;
      return Axios.get("/me")
        .then((res) => {
          let me = res.data;
          dispatch(login({ token, me }));
          dispatch(addCart());
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) dispatch(logout());
        });
    }
  };
};
export const addStore = (store) => ({ type: ADD_STORE, store });

export const addProductDetails = (data) => {
  return {
    type: ADD_PRODUCT_DETAILS,
    data,
  };
};
export const addProductToCart = (data) => {
  return async (dispatch) => {
    try {
      await Axios.post("SETPRODUCTTOSALEBASKET", {
        ProductID: data.product_id,
        RestaurantID: data.store_id,
        Count: data.count,
      });
      dispatch(
        updateCart({
          product_id: data.product_id,
          store_id: data.store_id,
          count: data.count,
        })
      );
      return data;
    } catch (err) {
      throw err;
    }
  };
};
export const addCart = (store_id) => ({
  type: ADD_CART,
  store_id,
});

export const updateCart = (data) => {
  return {
    type: UPDATE_CART,
    data,
  };
};
export const updateMessageCount = (count) => {
  return {
    type: UPDATE_MESSAGE_COUNT,
    count,
  };
};
export const updateUser = (user) => {
  return {
    type: UPDATE_USER,
    user: user,
  };
};

export const updateUserAndCart = (cart) => {
  return {
    type: UPDATE_USER_AND_CART,
    cart,
  };
};

export const setIsAuth = (value) => ({
  type: SET_IS_AUTH,
  value,
});
export const logout = () => {
  return {
    type: LOGOUT,
  };
};

export const removeCartFromStore = (store_id) => ({
  type: REMOVE_CART_FROM_STORE,
  store_id,
});
